module.exports = __webpack_public_path__ + "media/images/front/varieties/NAVEL-FOYOS-52af0c72e06e732babdde6fa24f7b1f8.jpg";